import React from 'react';
import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="-0.625 -0.625 24 24"
        id="Signature-Streamline-Flex"
    >
        <g id="signature">
            <path
                id="Vector 1054"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21.9375 18.74795c-7.0620062500000005 -0.471575 -14.062993749999999 -0.471575 -21.125 0"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 1118"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m1.421875 11.79553375 2.9081325 2.90801875"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 1119"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.32989375 11.79553375 1.4217612499999999 14.703552499999999"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 1224"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.3110375 21.9375C11.19664 16.05569875 17.02935 2.8950512500000003 13.24427 1.092196625 10.69263 -0.1231724 7.6892725 2.8013862499999997 7.31098875 6.3946675c-0.37828375 3.5932975 0.9335462499999999 6.59348625 5.09322125 6.930771249999999 4.15974 0.33726875 5.5983525 -2.395965 6.16044 -2.395965 0.5622499999999999 0 0.5060250000000001 3.42888 3.37285 3.42888"
                strokeWidth="1.25"
            ></path>
        </g>
    </svg>,
) as React.FC;
